import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { c as o } from "../../commons.module-WJbJq_Wu.js";
import { c as r } from "../../clsx-OuTLNxxd.js";
import { ExcursionActivityLevelIcon as l } from "./ExcursionActivityLevelIcon.js";
const m = "ExcursionActivityLevel-module_icons__nNUFN",
  a = {
    icons: m
  },
  N = _ref => {
    let {
      title: s,
      label: c,
      iconStep: e = 0,
      titleClassName: n = void 0
    } = _ref;
    return /* @__PURE__ */t("div", {
      className: o.boxContainer,
      children: [/* @__PURE__ */i("div", {
        className: r(o.boxTitle, n),
        children: s
      }), /* @__PURE__ */i("div", {
        className: a.icons,
        children: /* @__PURE__ */i(l, {
          iconStep: e
        })
      }), /* @__PURE__ */i("div", {
        className: o.boxLabel,
        children: c
      })]
    });
  };
export { N as ExcursionActivityLevel, N as default };